// extracted by mini-css-extract-plugin
export default {"breadcrumb":"breadcrumb_breadcrumb__8MhPV","items":"breadcrumb_items__WVCP5","item":"breadcrumb_item__OzoCe","icon":"breadcrumb_icon__NmDQL"};